// sessionStore.js
const sessionStore = {
    /**
     * 保存数据到 sessionStorage
     * @param {string} key 键名
     * @param {any} value 值（对象 / 数组 / 基本类型）
     */
    set(key, value) {
        try {
            const item = {
                type: value === null ? 'null' : typeof value,
                data: value
            };

            sessionStorage.setItem(key, JSON.stringify(item));
        } catch (error) {
            console.error(`sessionStore set error [${key}]:`, error);
        }
    },

    /**
     * 从 sessionStorage 获取数据
     * @param {string} key 键名
     * @param {any} defaultValue 默认值
     * @returns {any}
     */
    get(key, defaultValue = null) {
        try {
            const raw = sessionStorage.getItem(key);
            if (raw === null) return defaultValue;

            try {
                const parsed = JSON.parse(raw);

                // 新版结构：{ type, data }
                if (parsed && typeof parsed === 'object' && 'data' in parsed) {
                    return parsed.data;
                }

                // 旧版：直接 stringify 的值
                return parsed;
            } catch {
                // 更旧的数据：纯字符串
                return raw;
            }
        } catch (error) {
            console.error(`sessionStore get error [${key}]:`, error);
            return defaultValue;
        }
    },
    /**
     * 获取字符串类型
     * @param {string} key
     * @param {string} defaultValue
     * @returns {string}
     */
    getString(key, defaultValue = '') {
        const val = this.get(key, defaultValue);
        return typeof val === 'string' ? val : JSON.stringify(val);
    },

    /**
     * 获取 JSON 类型
     * @param {string} key
     * @param {any} defaultValue
     * @returns {object|array|null}
     */
    getJSON(key, defaultValue = null) {
        const val = this.get(key, defaultValue);
        if (typeof val === 'string') {
            try {
                return JSON.parse(val);
            } catch {
                return defaultValue;
            }
        }
        return val;
    },

    remove(key) {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            console.error(`sessionStore remove error [${key}]:`, error);
        }
    },

    clear() {
        try {
            sessionStorage.clear();
        } catch (error) {
            console.error('sessionStore clear error:', error);
        }
    }
};

export default sessionStore;